export default __webpack_public_path__ + "static/media/cry.93da900f.svg";